<template>
  <div class="warp">
    <!-- <iframe v-if="flage" class="inter" src="https://youji-ctp-ios.oss-cn-hangzhou.aliyuncs.com/AppHelp/index.html" frameborder="0"></iframe> -->
    <iframe v-if="flage" class="inter" src="" frameborder="0"></iframe>
    <!-- <iframe v-if="flage" class="inter" :src="helpAddress" frameborder="0"></iframe> -->
    <div class="headerWrapper">
      <span class="install" @click="goBack">
        <i class="icon iconfont">&#xe604;</i>
        返回
      </span>
      设置
    </div>
    <div class="setConent">
      <div class="section">
        <div class="sectionTitle">账户与安全</div>
        <ul class="panel">
          <li class="row">
            <div class="info">
              <span class="label">当前版本</span>
              <span class="desc">客户端版本信息</span>
            </div>
            <span class="value">{{versions}}</span>
          </li>
          <li class="row rowLink" @click="changeword">
            <div class="info">
              <span class="label">修改密码</span>
              <span class="desc">更新登录密码，提升账户安全性</span>
            </div>
            <span class="arrow">></span>
          </li>
        </ul>
      </div>

      <div class="section">
        <div class="sectionTitle">交易设置</div>
        <ul class="panel">
          <li class="row">
            <div class="info">
              <span class="label">委托确认</span>
              <span class="desc">下单、撤单、反手前进行二次确认</span>
            </div>
            <span class="right"><onoff/></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import art from "../../../static/js/proto/art/Art.js";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import * as SubUtils from "@/store/SubUtils";
import onoff from "../../views/Condition/components/OnOff/OnOff";
import * as version from '@/version.js';
export default {
  name: "setPage",
  components: {
    yjheader,
    onoff,
  },
  data() {
    return {
      versions: '',
      flage: false,
      helpAddress: '',
    }
  },

  methods: {
    goBack() {
      this.$router.push({ path: "/home/trade" });
    },
    lookHelp() {
      this.flage = true;
    },
    changeword() {
      this.$router.push('/ChangeWord')
    }
  },
  mounted() {
    this.versions = version.version;
    window.addEventListener('message', (e) => {
      // console.log(e.data);
      this.flage = e.data;
    })
  },
  activated() {
      this.helpAddress = helpAddress;
  },
};
</script>

<style scoped>
.warp {
  position: absolute;
  inset: 0;
  width: 100%;
  background:
    radial-gradient(circle at top, rgba(29, 78, 216, 0.08) 0%, rgba(11, 14, 17, 0) 32%),
    #0b0e11;
  color: #eaecef;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  font-feature-settings: "tnum" 1, "lnum" 1;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}
.iconfont {
  color: #d9e2ec;
  font-size: 0.3rem;
}
.headerWrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 1rem;
  padding: 0 1.2rem;
  box-sizing: border-box;
  background: linear-gradient(90deg, #111822 0%, #141b1f 100%);
  color: #f4f7fb;
  font-size: 0.34rem;
  font-weight: 600;
  letter-spacing: 0;
  border-bottom: 1px solid rgba(58, 68, 82, 0.9);
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.16);
}
.headerWrapper .install {
  position: absolute;
  left: 0.16rem;
  top: 50%;
  transform: translateY(-50%);
  color: #d9e2ec;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-weight: 500;
}
.setConent {
  width: 100%;
  position: absolute;
  top: 1rem;
  bottom: 0;
  padding: 0.18rem 0.16rem 0.28rem;
  box-sizing: border-box;
  overflow: auto;
}

.section + .section {
  margin-top: 0.18rem;
}

.sectionTitle {
  margin: 0 0 0.1rem 0.02rem;
  color: #7f8a98;
  font-size: 0.22rem;
  line-height: 0.32rem;
  letter-spacing: 0.01rem;
}

.panel {
  border-radius: 0.14rem;
  overflow: hidden;
  border: 1px solid rgba(43, 49, 57, 0.95);
  background: linear-gradient(180deg, rgba(18, 23, 30, 0.98) 0%, rgba(13, 18, 24, 0.98) 100%);
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.2);
}

.row{
  min-height: 1rem;
  padding: 0.18rem 0.18rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.18rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(43, 49, 57, 0.88);
  -webkit-tap-highlight-color: transparent;
}

.panel .row:last-child {
  border-bottom: none;
}

.rowLink:active {
  background: rgba(255, 255, 255, 0.02);
}

.info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.04rem;
}

.label,
.desc,
.value,
.arrow {
  white-space: nowrap;
}

.label {
  font-size: 0.29rem;
  line-height: 0.4rem;
  color: #eef2f7;
  font-weight: 500;
}

.desc {
  font-size: 0.22rem;
  line-height: 0.32rem;
  color: #7f8a98;
}

.value {
  color: #b7c0cc;
  font-size: 0.27rem;
  line-height: 0.36rem;
  font-weight: 500;
  letter-spacing: 0.01rem;
}

.arrow {
  color: #617082;
  font-size: 0.28rem;
  min-width: 0;
}

.right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
}
.inter {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
  height: 100%;
  font-size: 0.2rem;
  background: #161712;
  /* margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top); */
}
</style>



// WEBPACK FOOTER //
// src/components/yj/setPage.vue